import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';


class Notification extends Component {
  render() {
    const { classes } = this.props;

    const message = this.props.message || this.props.errorMessage;
    const className = this.props.errorMessage ? classes.error : classes.info;

    if (!message) {
      return null;
    }

    return (
      <Snackbar
        open={this.props.open}
        message={message}
        autoHideDuration={3000}
        onClose={this.props.onCloseNotification}
      >
        <SnackbarContent
          className={className}
          message={message}
        />
      </Snackbar>
    );
  }
}

Notification.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  onCloseNotification: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

Notification.defaultProps = {
  message: null,
  errorMessage: null,
};

const styles = theme => ({
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
});

export default withStyles(styles)(Notification);
